import type { ColumnPinningState, RowData } from "@tanstack/react-table";
import {
    getDefaultColumnState,
    getLeafColumnInfos,
} from "../columns/columnLayout";
import type {
    DataGridColumn,
    DataGridColumnInstance,
    DataGridPin,
} from "../columns/types";

/** Column pinning seeded from `meta.pin` on the leaf column definitions. */
export const getInitialColumnPinning = <TData extends RowData>(
    columnDefs: ReadonlyArray<DataGridColumn<TData>>,
): ColumnPinningState =>
    getDefaultColumnState(getLeafColumnInfos(columnDefs)).pinning;

/**
 * `start` on the last start-pinned column and `end` on the first end-pinned
 * one: the edges that draw a border while content scrolls under them.
 */
export const getPinEdge = <TData extends RowData>(
    column: DataGridColumnInstance<TData>,
): DataGridPin | undefined => {
    const pin = column.getIsPinned();
    if (pin === "start") {
        const starts = column.table.getStartVisibleLeafColumns();
        return starts[starts.length - 1]?.id === column.id
            ? "start"
            : undefined;
    }
    if (pin === "end") {
        return column.table.getEndVisibleLeafColumns()[0]?.id === column.id
            ? "end"
            : undefined;
    }
    return undefined;
};
